<mat-sidenav-container>
  @if (showSidenav) {
    <mat-sidenav #sidenav mode="over">
      <!-- Condominium navigation links -->
      <div class="sidenav-content">
      @if (showCondominiumLinks && condominiumId) {
          <!-- Owner-only links -->
          @if (isOwner) {
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'dashboard']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>dashboard</mat-icon>
              <span>Dashboard</span>
            </a>
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'tasks']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>assignment</mat-icon>
              <span>Tarefas</span>
            </a>
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'invitations']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>mail_outline</mat-icon>
              <span>Convites</span>
            </a>
          }
          <!-- Links for all users -->
          <a mat-list-item [routerLink]="['/condominium', condominiumId, 'tickets']" routerLinkActive="active" (click)="sidenav.close()">
            <mat-icon>confirmation_number</mat-icon>
            <span>Chamados</span>
          </a>
          <a mat-list-item [routerLink]="['/condominium', condominiumId, 'communications']" routerLinkActive="active" (click)="sidenav.close()">
            <mat-icon>forum</mat-icon>
            <span>Comunicados</span>
          </a>
          @if (isOwner) {
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'subscription']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>card_membership</mat-icon>
              <span>Meu plano</span>
            </a>
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'payments']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>payments</mat-icon>
              <span>Pagamentos</span>
            </a>
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'registration']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>apartment</mat-icon>
              <span>Registro</span>
            </a>
            <a mat-list-item [routerLink]="['/condominium', condominiumId, 'change-owner']" routerLinkActive="active" (click)="sidenav.close()">
              <mat-icon>admin_panel_settings</mat-icon>
              <span>Trocar síndico</span>
            </a>
          }
          <a mat-list-item [routerLink]="['/condominium', condominiumId, 'members']" routerLinkActive="active" (click)="sidenav.close()">
            <mat-icon>group</mat-icon>
            <span>Membros</span>
          </a>
          <a mat-list-item [routerLink]="['/condominium', condominiumId, 'info']" routerLinkActive="active" (click)="sidenav.close()">
            <mat-icon>info</mat-icon>
            <span>Informações do condomínio</span>
          </a>
          <!-- Link back to condominium selection -->
          <mat-divider></mat-divider>
        }
        <a mat-list-item [routerLink]="['/condominiums']" (click)="sidenav.close()">
          <mat-icon>home</mat-icon>
          <span>Meus condomínios</span>
        </a>
      </div>
    </mat-sidenav>
  }
  <mat-sidenav-content>
    @if (!isHomeRoute) {
      <app-toolbar (menuClick)="onMenuClick()"></app-toolbar>
    }
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
